import React from "react";
import Modal from "../../../../../../../components/Modal/Modal";
import Button from "../../../../../../../components/Button/Button";
import DeleteTrashOpenIcon from "../../../../../../../assets/svg/delete-trash-open-icon";
import { HelpdeskViewItem } from "../utils/types";

interface DeleteViewModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirmDelete: () => Promise<void>;
  view: HelpdeskViewItem;
  isDeleting: boolean;
}

const DeleteViewModal: React.FC<DeleteViewModalProps> = ({
  open,
  onOpenChange,
  onConfirmDelete,
  view,
  isDeleting,
}) => {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      preventOutsideClick={false}
      customHeader={
        <div className="flex items-center gap-2 flex-1">
          <DeleteTrashOpenIcon className="w-4 h-4 text-verba-red-alert dark:text-verba-red-alert-dk" />
          <span className="text-heading-text dark:text-heading-text-dk font-medium text-base mt-0.5">
            Delete Custom View
          </span>
        </div>
      }
      headerClassName="px-4 pt-4 pb-0"
      contentClassName="w-[326px] border border-border-gray dark:border-border-gray-dk bg-fixed-white dark:bg-popper-bg-dk backdrop-blur-[10px]"
      overlayClassName="bg-black/80"
      bodyClassName="!p-0"
    >
      <div className="flex flex-col p-4" onClick={(e) => e?.stopPropagation()}>
        <p className="text-xs font-normal text-data dark:text-data-dk leading-relaxed mb-6">
          Delete this view? This action cannot be undone.
        </p>

        <div className="flex items-center gap-[2px] h-[26px] px-[6px] rounded-md border border-border-gray dark:border-border-gray-dk bg-tag-gray dark:bg-tag-gray-dk w-fit mb-12">
          {view?.emoji_icon && (
            <span className="text-md leading-none shrink-0">
              {view.emoji_icon}
            </span>
          )}
          <span className="text-sm whitespace-nowrap text-verba-indigo dark:text-verba-indigo-dk">
            {view?.name}
          </span>
        </div>

        <div className="flex items-center justify-end gap-2">
          <Button
            innerText="Cancel"
            onClick={() => onOpenChange(false)}
            disabled={isDeleting}
            buttonContainerClass="min-w-[100px] min-h-[26px] py-[2px] px-2 text-md border border-verba-indigo dark:border-verba-indigo-dk hover:border-transparent bg-verba-indigo text-pure-white dark:text-pure-white-dk dark:bg-verba-indigo-dk rounded-md cursor-pointer hover:bg-verba-blue dark:hover:bg-verba-blue-dk hover:text-fixed-white-light-and-dark-mode dark:hover:text-fixed-white-light-and-dark-mode-dk transition-colors duration-200"
            innerTextClass="text-md font-semibold"
          />
          <Button
            innerText={isDeleting ? "Deleting..." : "Delete View"}
            onClick={onConfirmDelete}
            disabled={isDeleting}
            buttonContainerClass="disabled:opacity-30 min-w-[100px] min-h-[26px] py-[2px] px-6 text-md border border-verba-red-alert dark:border-verba-red-alert-dk bg-transparent dark:bg-transparent rounded-md cursor-pointer text-verba-red-alert dark:text-verba-red-alert-dk hover:bg-verba-red-alert dark:hover:bg-verba-red-alert-dk hover:text-fixed-white-light-and-dark-mode dark:hover:text-fixed-white-light-and-dark-mode-dk transition-colors duration-200 disabled:hover:bg-transparent disabled:hover:text-verba-red-alert disabled:hover:dark:text-verba-red-alert-dk dark:disabled:hover:bg-transparent"
            innerTextClass="text-md font-semibold"
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteViewModal;
